<app-smart-table *ngIf="definition.cols.length"
                 [data]="data"
                 [definition]="definition">
</app-smart-table>
